import React, { useState, useEffect, useRef } from "react";
import { useSelector, shallowEqual } from "react-redux";
import Portal from "../portal";
import { FiX } from "react-icons/fi";
import { API_CreateCategory, url, API_MasterCategoryList } from "../../apis/constant";
import { toast } from "react-toastify";
import ApiClient from "../../apis/apiClient";
import axios from "axios";
import AsyncSelect from "react-select/async";

const AddCategory = ({ title, getApi }) => {
  const alphanumericRegex = /^[^'"`]+$/;
  const adminToken = localStorage.getItem("wed_admin_token");
  const [error, setError] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [nameValue, setNameValue] = useState("");
  const [slugValue, setSlugValue] = useState("");
  const [seletItem, setSelectItem] = useState("");
  const [selectItemError, setselectItemError] = useState("");
  const [selectedValue, setSelectedValue] = useState(null);
  const [showOnHomepage, setShowOnHomepage] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const { palettes } = useSelector(
    (state) => ({
      palettes: state.palettes,
    }),
    shallowEqual
  );
  let { background } = { ...palettes };

  const modalRef = useRef(null);
  const [open, setOpen] = useState(false);
  const show = () => setOpen(true);
  const hide = () => {
    setOpen(false);
    setNameValue("");
    setSelectItem("");
    setSlugValue("");
    setIsSubmit(false);
    setSelectedValue("");
    setSelectItem("");
    setselectItemError("");
    setShowOnHomepage(false);
    setSelectedFile(null);
  };

  useEffect(() => {
    getAllMasterCategpry("");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectValue = (e) => {
    setSelectedValue(e);
    setSelectItem(e.id);
  };

  const getAllMasterCategpry = async (inputValue) => {
    const data = "";
    const res = await ApiClient.get(
      API_MasterCategoryList + `?page=1&sortBy=asc&limit=${99999}&searchBy=${inputValue}`,
      data,
      `Bearer ${adminToken}`
    );
    if (res.data.code === 200) {
      let activeData = res?.data?.data?.docs?.filter(item => item.status === 1);
      return activeData;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!modalRef || !modalRef.current) return false;
      if (!open || modalRef.current.contains(event.target)) return false;
      setOpen(!open);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open, modalRef]);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleNameValue = (value) => {
    const limit = 200;
    if (value.length > limit) {
      setError("Please enter less than 200 words.");
    } else if (value && !alphanumericRegex.test(value)) {
      setError("Please enter valid name.");
      setNameValue(value);
      return;
    } else {
      setError("");
      setNameValue(value);
    }
  };

  const handleSlugValue = (value) => {
    setSlugValue(value);
  };

  const handleCategory = () => {
    let isInvalid = false;
    setError("");
    setselectItemError("");
    setIsSubmit(true);
    if (nameValue === "") {
      setError("Name should not be blank.");
      setIsSubmit(false);
      isInvalid = true;
    }

    if (slugValue === "") {
      setError("Slug should not be blank.");
      setIsSubmit(false);
      isInvalid = true;
    }

    if (slugValue.length < 3) {
      setError("Slug length should be greater than 2 characters.");
      setIsSubmit(false);
      isInvalid = true;
    }

    if (seletItem === "") {
      setselectItemError("Please choose Level 1.");
      setIsSubmit(false);
      isInvalid = true;
    }

    if (isInvalid) return;

    const formData = new FormData();
    formData.append("name", nameValue);
    formData.append("masterCategoryId", seletItem);
    formData.append("slug", slugValue);
    formData.append("showOnHomepage", showOnHomepage);
    if (selectedFile) {
      formData.append("image", selectedFile);
    }

    axios
      .post(url + API_CreateCategory, formData, {
        headers: { Authorization: `Bearer ${adminToken}` },
      })
      .then((res) => {
        if (res.data.code === 200) {
          toast.success(res.data.message);
          hide();
          getApi(10, 1);
        } else if (res.data.code === 400) {
          toast.error(res.data.message);
          setIsSubmit(false);
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response?.data?.message || "Error occurred");
      });
  };

  return (
    <>
      <button
        className="btn btn-default btn-rounded bg-blue-500 hover:bg-blue-600 text-white addCategoryCss"
        type="button"
        onClick={show}
      >
        Add Level 2
      </button>
      {open && (
        <Portal selector="#portal">
          <div className="modal-backdrop fade-in"></div>
          <div className={`modal show ${background === "dark" ? "dark-mode" : ""}`} data-background={background}>
            <div className="relative min-w-sm w-auto mx-auto lg:max-w-5xl" ref={modalRef}>
              <div className="modal-content">
                <div className="modal-header">
                  <h3 className="text-xl font-semibold">{title}</h3>
                  <button className="modal-close btn btn-transparent" onClick={hide}>
                    <FiX size={18} className="stroke-current" />
                  </button>
                </div>
                <div className="relative p-4 flex-auto">
                  <label>Title:</label>
                  <div className="inputBoxCategoryCss">
                    <input
                      type="text"
                      placeholder="Please Enter Title"
                      name="name"
                      value={nameValue}
                      onChange={(e) => handleNameValue(e.target.value)}
                      className="inputFields"
                    />
                  </div>
                  <label className="mt-3 block">Slug:</label>
                  <div className="inputBoxCategoryCss">
                    <input
                      type="text"
                      placeholder="Please Enter Slug"
                      name="slug"
                      value={slugValue}
                      onChange={(e) => handleSlugValue(e.target.value)}
                      className="inputFields"
                    />
                  </div>
                  <label className="mt-3 block">Image:</label>
                  <div className="inputBoxCategoryCss">
                    <input type="file" accept="image/*" onChange={handleFileChange} className="inputFields" />
                  </div>
                  <div className="mt-3 flex items-center gap-2">
                    <input
                      type="checkbox"
                      id="showOnHomepage"
                      checked={showOnHomepage}
                      onChange={(e) => setShowOnHomepage(e.target.checked)}
                      className="form-checkbox h-4 w-4"
                    />
                    <label htmlFor="showOnHomepage" className="text-sm text-gray-700">
                      Show on Homepage
                    </label>
                  </div>
                  {error && <p style={{ color: "red", padding: "10px 4px" }}>{error}</p>}
                </div>
                <div className="form-element">
                  <div className="form-label" style={{ marginLeft: "5px" }}>
                    Level 1:
                  </div>
                  <AsyncSelect
                    className="selectWithSearch"
                    cacheOptions
                    defaultOptions
                    value={selectedValue}
                    getOptionLabel={(e) => e.name}
                    getOptionValue={(e) => e.id}
                    loadOptions={getAllMasterCategpry}
                    onChange={handleSelectValue}
                  />
                  {selectItemError && (
                    <p style={{ color: "red", padding: "10px 4px", paddingLeft: "20px" }}>
                      {selectItemError}
                    </p>
                  )}
                </div>
                <div className="modal-footer space-x-2">
                  <button className="btn btn-default btn-rounded bg-blue-500 hover:bg-blue-600 text-white" type="button" onClick={hide}>
                    Close
                  </button>
                  {isSubmit ? (
                    <button className="btn btn-default btn-rounded bg-blue-500 hover:bg-blue-600 text-white" type="button">
                      Loading...
                    </button>
                  ) : (
                    <button className="btn btn-default btn-rounded bg-blue-500 hover:bg-blue-600 text-white" type="button" onClick={handleCategory}>
                      Save Changes
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Portal>
      )}
    </>
  );
};

export default AddCategory;